module.exports = __webpack_public_path__ + "img/카톡.76a9ab76.png";